// SpendingsConstants.js
import keyMirror from 'keymirror';

export default keyMirror({
  REQUEST_ALL_ACCOUNTS: null,
  REQUEST_ALL_ACCOUNTS_SUCCESS: null,
  REQUEST_ALL_ACCOUNTS_ERROR: null,
  REQUEST_SPENDING_PAGE_ON_TOGGLE: null,
  REQUEST_SPENDING_PAGE_ON_BACK: null,
  REQUEST_SPENDING_PAGE: null,
  REQUEST_EARNING_PAGE: null,
  REQUEST_SPEND_LIST_CONNECTION: null,
  REQUEST_SPEND_LIST_CONNECTION_SUCCESS: null,
  REQUEST_SPEND_LIST_CONNECTION_ERROR: null,
  REQUEST_BUDGET_CONNECTION: null,
  REQUEST_BUDGET_CONNECTION_SUCCESS: null,
  REQUEST_BUDGET_CONNECTION_ERROR: null,
  REQUEST_BUDGET_PREFERENCES_CONNECTION: null,
  REQUEST_BUDGET_PREFERENCES_CONNECTION_SUCCESS: null,
  REQUEST_BUDGET_PREFERENCES_CONNECTION_ERROR: null,
  UPDATE_BUDGET_PREFERENCES_CONNECTION: null,
  UPDATE_BUDGET_PREFERENCES_CONNECTION_SUCCESS: null,
  REQUEST_TAG_LIST_CONNECTION: null,
  REQUEST_TAG_LIST_CONNECTION_SUCCESS: null,
  REQUEST_EDIT_BUDGET_PAGE: null,
  REQUEST_TRANSACTIONS: null,
  REQUEST_NEXT_TRANSACTIONS: null,
  REQUEST_TRANSACTIONS_ON_SORT: null,
  REQUEST_TRANSACTIONS_ON_SORT_SUCCESS: null,
  REQUEST_TRANSACTIONS_SUCCESS: null,
  UPDATE_BUDGET_CONNECTION: null,
  UPDATE_BUDGET_CONNECTION_SUCCESS: null,
  UPDATE_BUDGET_CONNECTION_ERROR: null,
  REQUEST_TAG_LIST_CONNECTION_ERROR: null,
  UPDATE_BUDGET_PREFERENCES_CONNECTION_ERROR: null,
  REQUEST_ALL_SELECTED_ACCOUNTS: null,
  REQUEST_CLOSE_ACCOUNT_MODAL: null,
  REQUEST_POT_DATA_SPENDINGS: null,
  REQUEST_POT_DATA_SPENDINGS_SUCCESS: null,
  REQUEST_POT_DATA_SPENDINGS_ERROR: null,
  UPDATED_CREATE_BUDGET_DATA: null,
  REQUEST_TRANSACTIONS_ERROR: null,
});
